<template>
  <ExActionsPopUp
    :value="value"
    icon="checkpoint_pass"
    :destructive="true"
    :headline="'Discard Proposed Changes'"
    :htmlInfo="info"
    :actionLabel="'OK'"
    :cancelLabel="'Cancel'"
    :backgroundPatternBottomRight="true"
    :applyBorderClass="true"
    :width="500"
    :z-index="zIndex"
    :centerHeadline="true"
    actionsTopSpacing="32px"
    data-testid="discard-proposed-changes-dialog"
    @onAction="emit('onAction')"
    @input="emit('input', $event)"
  />
</template>

<script>
export default {
  name: "DiscardProposedChangesDialog",
};
</script>

<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";

defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  zIndex: {
    type: [Number, String],
    default: undefined,
  },
});

const emit = defineEmits(["onAction", "input"]);

const info = computed(
  () =>
    `You are about to discard proposed changes.<br />
        This action is irreversible.`
);
</script>

<style scoped>
::v-deep .action_popup_message.message-spaced {
  max-width: 284px !important /* stylelint-disable-line declaration-no-important */;
  margin: 10px auto 0 !important /* stylelint-disable-line declaration-no-important */;
  text-align: center !important /* stylelint-disable-line declaration-no-important */;
}
</style>
